/* VCTparts: compare products on collection, search and product pages.
   Compare mode: nothing shows until the visitor turns it on with the
   "Vergelijken" button in the collection/search toolbar
   (snippets/vct-compare-mode-button.liquid) or adds a product with the
   "Vergelijk" button on a product page. In compare mode the html element has
   the class vct-cmp-mode and every card shows its tick (CSS).
   Data: every product card on collection and search pages carries its data in
   data-vct-cmp (snippets/product-item.liquid -> snippets/vct-compare-data.liquid);
   the product page has a "Vergelijk" button in the meta row under the title
   (sections/main-product.liquid) with the same data plus the specification
   lines of that page. Rows come from the specification metafields, price,
   stars, brand, stock and, for dashcams, the metafield vct.vergelijk.
   Same kind only: the deepest collection of the menu 'categorieen' the
   product is in (snippets/vct-compare-config.liquid) must match the first
   chosen product.
   Up to 3 products (4 on screens from 1100px) are kept in localStorage for
   7 days. A bar at the bottom (class vct-cmp-bar: snippets/vct-chat.liquid
   lifts the chat button above it) opens the comparison: a sheet on phones, a
   panel on desktop. Styling: assets/vct-modern.css section 17. */
(function () {
  'use strict';

  var KEY = 'vct-cmp-v2';
  var TTL = 7 * 24 * 60 * 60 * 1000;
  var LANG = (document.documentElement.lang || 'nl').slice(0, 2).toLowerCase();
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var CFG = {};
  try { CFG = JSON.parse((document.getElementById('vct-cmp-config') || {}).textContent || '{}') || {}; } catch (e) { CFG = {}; }
  var IS_PDP = CFG.tpl === 'product' || !!document.querySelector('[data-vct-cmp-add]');
  var mqWide = window.matchMedia('(min-width: 1100px)');
  var mqPhone = window.matchMedia('(max-width: 749px)');
  function max() { return mqWide.matches ? 4 : 3; }

  var T = {
    nl: {
      compare: 'Vergelijk', inCompare: 'In vergelijking', compareN: 'Vergelijk ({n})', clear: 'Wissen', stop: 'Stoppen', pick3: 'Kies 2 of 3 producten', pick4: 'Kies 2 tot 4 producten',
      title: 'Producten vergelijken', titleKind: '{kind} vergelijken', count: '{n} van {max} gekozen',
      pickMore: 'Kies nog een product om te vergelijken', max: 'Je kunt maximaal {n} producten vergelijken. Haal er eerst een weg.',
      other: 'Dit product is een ander soort dan je vergelijking ({kind}).', otherNoKind: 'Dit product is een ander soort dan je vergelijking.',
      startNew: 'Nieuwe vergelijking starten', close: 'Sluiten', remove: 'Verwijderen', view: 'Bekijk',
      addCart: 'In winkelwagen', choose: 'Kies uitvoering', adding: 'Toevoegen…', added: 'Toegevoegd',
      addFail: 'Toevoegen lukt niet. Probeer het opnieuw.', soldOut: 'Uitverkocht', diffOnly: 'Toon alleen verschillen',
      best: 'Beste waarde', ratingOf: '{r} van 5 sterren', yes: 'Ja', no: 'Nee', years1: '1 jaar', yearsN: '{n} jaar',
      inStock: 'Op voorraad', backorder: 'Wordt nabesteld', price: 'Prijs', rating: 'Beoordeling', stock: 'Voorraad', merk: 'Merk',
      voltage: 'Voltage', fitting: 'Fitting', lichtbron: 'Lichtbron', kelvin: 'Kleurtemperatuur', kleur: 'Kleur', toepassing: 'Toepassing',
      inbouw: 'Inbouw mogelijk', inhoud: 'Inhoud', velgen: 'Aantal velgen', inch: 'Inchmaat', steek: 'Steekmaat', et: 'ET-waarde',
      garantie: 'Garantie', lumen: 'Lichtopbrengst', vermogen: 'Vermogen',
      cams: "Camera's", front: 'Resolutie voorcamera', rear: 'Resolutie achtercamera', interior: 'Interieurcamera',
      wifi: 'WiFi en app', gps: 'GPS', screen: 'Scherm', parking: 'Parkeerbewaking', night: 'Nachtzicht',
      fov: 'Kijkhoek', sd: 'Geheugenkaart', gsensor: 'Botsdetectie (G-sensor)', hardwire: 'Continue voeding meegeleverd',
      cam1: '1 (voor)', cam2: '2 (voor + achter)', cam3: '3 (voor, achter en interieur)',
      builtIn: 'Ingebouwd', ir: 'Infrarood', mode: 'Nachtmodus', inchU: 'inch', sdUpTo: 'microSD tot {n} GB',
      parkingHw: 'Ja, met continue voeding (los verkrijgbaar)',
      note: '– = niet vermeld. Bekijk de productpagina voor alle details.'
    },
    de: {
      compare: 'Vergleichen', inCompare: 'Im Vergleich', compareN: 'Vergleichen ({n})', clear: 'Leeren', stop: 'Beenden', pick3: 'Wähle 2 oder 3 Produkte', pick4: 'Wähle 2 bis 4 Produkte',
      title: 'Produkte vergleichen', titleKind: '{kind} vergleichen', count: '{n} von {max} gewählt',
      pickMore: 'Wähle noch ein Produkt zum Vergleichen', max: 'Du kannst höchstens {n} Produkte vergleichen. Entferne zuerst eines.',
      other: 'Dieses Produkt ist eine andere Art als dein Vergleich ({kind}).', otherNoKind: 'Dieses Produkt ist eine andere Art als dein Vergleich.',
      startNew: 'Neuen Vergleich starten', close: 'Schließen', remove: 'Entfernen', view: 'Ansehen',
      addCart: 'In den Warenkorb', choose: 'Variante wählen', adding: 'Wird hinzugefügt…', added: 'Hinzugefügt',
      addFail: 'Hinzufügen hat nicht geklappt. Bitte versuche es erneut.', soldOut: 'Ausverkauft', diffOnly: 'Nur Unterschiede zeigen',
      best: 'Bester Wert', ratingOf: '{r} von 5 Sternen', yes: 'Ja', no: 'Nein', years1: '1 Jahr', yearsN: '{n} Jahre',
      inStock: 'Auf Lager', backorder: 'Wird nachbestellt', price: 'Preis', rating: 'Bewertung', stock: 'Verfügbarkeit', merk: 'Marke',
      voltage: 'Spannung', fitting: 'Sockel', lichtbron: 'Leuchtmittel', kelvin: 'Farbtemperatur', kleur: 'Farbe', toepassing: 'Anwendung',
      inbouw: 'Einbau möglich', inhoud: 'Inhalt', velgen: 'Anzahl Felgen', inch: 'Zollgröße', steek: 'Lochkreis', et: 'ET-Wert',
      garantie: 'Gewährleistung', lumen: 'Lichtstrom', vermogen: 'Leistung',
      cams: 'Kameras', front: 'Auflösung Frontkamera', rear: 'Auflösung Heckkamera', interior: 'Innenraumkamera',
      wifi: 'WLAN und App', gps: 'GPS', screen: 'Display', parking: 'Parküberwachung', night: 'Nachtsicht',
      fov: 'Blickwinkel', sd: 'Speicherkarte', gsensor: 'Aufprallerkennung (G-Sensor)', hardwire: 'Dauerstromkabel enthalten',
      cam1: '1 (vorne)', cam2: '2 (vorne + hinten)', cam3: '3 (vorne, hinten und Innenraum)',
      builtIn: 'Integriert', ir: 'Infrarot', mode: 'Nachtmodus', inchU: 'Zoll', sdUpTo: 'microSD bis {n} GB',
      parkingHw: 'Ja, mit Dauerstromkabel (separat erhältlich)',
      note: '– = nicht angegeben. Alle Details findest du auf der Produktseite.'
    },
    fr: {
      compare: 'Comparer', inCompare: 'Dans le comparateur', compareN: 'Comparer ({n})', clear: 'Effacer', stop: 'Arrêter', pick3: 'Choisissez 2 ou 3 produits', pick4: 'Choisissez 2 à 4 produits',
      title: 'Comparer des produits', titleKind: 'Comparer : {kind}', count: '{n} sur {max} choisis',
      pickMore: 'Choisissez encore un produit à comparer', max: 'Vous pouvez comparer {n} produits au maximum. Retirez-en un d’abord.',
      other: 'Ce produit est d’un autre type que votre comparaison ({kind}).', otherNoKind: 'Ce produit est d’un autre type que votre comparaison.',
      startNew: 'Commencer une nouvelle comparaison', close: 'Fermer', remove: 'Retirer', view: 'Voir',
      addCart: 'Ajouter au panier', choose: 'Choisir une variante', adding: 'Ajout…', added: 'Ajouté',
      addFail: 'L’ajout n’a pas réussi. Réessayez.', soldOut: 'Épuisé', diffOnly: 'Afficher uniquement les différences',
      best: 'Meilleure valeur', ratingOf: '{r} sur 5 étoiles', yes: 'Oui', no: 'Non', years1: '1 an', yearsN: '{n} ans',
      inStock: 'En stock', backorder: 'En réassort', price: 'Prix', rating: 'Avis', stock: 'Stock', merk: 'Marque',
      voltage: 'Tension', fitting: 'Culot', lichtbron: 'Source lumineuse', kelvin: 'Température de couleur', kleur: 'Couleur', toepassing: 'Application',
      inbouw: 'Montage possible', inhoud: 'Contenance', velgen: 'Nombre de jantes', inch: 'Taille (pouces)', steek: 'Entraxe', et: 'Déport (ET)',
      garantie: 'Garantie', lumen: 'Flux lumineux', vermogen: 'Puissance',
      cams: 'Caméras', front: 'Résolution caméra avant', rear: 'Résolution caméra arrière', interior: 'Caméra intérieure',
      wifi: 'Wi-Fi et appli', gps: 'GPS', screen: 'Écran', parking: 'Surveillance parking', night: 'Vision nocturne',
      fov: 'Angle de vue', sd: 'Carte mémoire', gsensor: 'Détection de choc (G-sensor)', hardwire: 'Alimentation permanente incluse',
      cam1: '1 (avant)', cam2: '2 (avant + arrière)', cam3: '3 (avant, arrière et intérieur)',
      builtIn: 'Intégré', ir: 'Infrarouge', mode: 'Mode nuit', inchU: 'pouces', sdUpTo: 'microSD jusqu’à {n} Go',
      parkingHw: 'Oui, avec alimentation permanente (vendue séparément)',
      note: '– = non indiqué. Consultez la page produit pour tous les détails.'
    },
    en: {
      compare: 'Compare', inCompare: 'In comparison', compareN: 'Compare ({n})', clear: 'Clear', stop: 'Stop', pick3: 'Choose 2 or 3 products', pick4: 'Choose 2 to 4 products',
      title: 'Compare products', titleKind: 'Compare {kind}', count: '{n} of {max} chosen',
      pickMore: 'Pick one more product to compare', max: 'You can compare up to {n} products. Remove one first.',
      other: 'This product is a different kind than your comparison ({kind}).', otherNoKind: 'This product is a different kind than your comparison.',
      startNew: 'Start a new comparison', close: 'Close', remove: 'Remove', view: 'View',
      addCart: 'Add to cart', choose: 'Choose option', adding: 'Adding…', added: 'Added',
      addFail: 'Adding did not work. Please try again.', soldOut: 'Sold out', diffOnly: 'Show differences only',
      best: 'Best value', ratingOf: '{r} out of 5 stars', yes: 'Yes', no: 'No', years1: '1 year', yearsN: '{n} years',
      inStock: 'In stock', backorder: 'On backorder', price: 'Price', rating: 'Rating', stock: 'Stock', merk: 'Brand',
      voltage: 'Voltage', fitting: 'Fitting', lichtbron: 'Light source', kelvin: 'Colour temperature', kleur: 'Colour', toepassing: 'Use',
      inbouw: 'Installation possible', inhoud: 'Contents', velgen: 'Number of rims', inch: 'Rim size', steek: 'Bolt pattern', et: 'ET value',
      garantie: 'Warranty', lumen: 'Luminous flux', vermogen: 'Power',
      cams: 'Cameras', front: 'Front camera resolution', rear: 'Rear camera resolution', interior: 'Interior camera',
      wifi: 'Wi-Fi and app', gps: 'GPS', screen: 'Screen', parking: 'Parking mode', night: 'Night vision',
      fov: 'Field of view', sd: 'Memory card', gsensor: 'Impact detection (G-sensor)', hardwire: 'Hardwire kit included',
      cam1: '1 (front)', cam2: '2 (front + rear)', cam3: '3 (front, rear and interior)',
      builtIn: 'Built in', ir: 'Infrared', mode: 'Night mode', inchU: 'inch', sdUpTo: 'microSD up to {n} GB',
      parkingHw: 'Yes, with hardwire kit (sold separately)',
      note: '– = not stated. See the product page for all details.'
    }
  };
  var t = T[LANG] || T.nl;
  function tr(s, o) { return String(s).replace(/\{(\w+)\}/g, function (m, k) { return o && o[k] != null ? o[k] : m; }); }

  /* Dashcam rows (metafield vct.vergelijk), then the specification rows */
  var CAM_ROWS = ['cams', 'front', 'rear', 'interior', 'wifi', 'gps', 'screen', 'parking', 'night', 'fov', 'sd', 'gsensor', 'hardwire'];
  var SPEC_ROWS = ['lumen', 'vermogen', 'fitting', 'lichtbron', 'kelvin', 'kleur', 'voltage', 'toepassing', 'inbouw', 'inhoud', 'velgen', 'inch', 'steek', 'et'];
  /* Spec labels as written on product pages (any language), lower case without spaces and signs */
  var SYN = {
    merk: 'merk', brand: 'merk', marke: 'merk', marque: 'merk', hersteller: 'merk',
    kelvin: 'kelvin', kleurtemperatuur: 'kelvin', kleurtemp: 'kelvin', lichtkleur: 'kelvin', farbtemperatur: 'kelvin',
    lichtfarbe: 'kelvin', temperaturedecouleur: 'kelvin', colourtemperature: 'kelvin', colortemperature: 'kelvin',
    voltage: 'voltage', spanning: 'voltage', spannung: 'voltage', tension: 'voltage', volt: 'voltage',
    fitting: 'fitting', lampfitting: 'fitting', lampvoet: 'fitting', sockel: 'fitting', culot: 'fitting', socket: 'fitting',
    lichtbron: 'lichtbron', leuchtmittel: 'lichtbron', lichtquelle: 'lichtbron', sourcelumineuse: 'lichtbron', lightsource: 'lichtbron',
    kleur: 'kleur', farbe: 'kleur', couleur: 'kleur', colour: 'kleur', color: 'kleur',
    toepassing: 'toepassing', anwendung: 'toepassing', application: 'toepassing', gebruik: 'toepassing',
    inbouwmogelijk: 'inbouw', einbaumoglich: 'inbouw', montagepossible: 'inbouw',
    inhoud: 'inhoud', inhalt: 'inhoud', contenance: 'inhoud', contenu: 'inhoud', volume: 'inhoud',
    lumen: 'lumen', lichtopbrengst: 'lumen', lichtstroom: 'lumen', lichtstrom: 'lumen', fluxlumineux: 'lumen',
    vermogen: 'vermogen', wattage: 'vermogen', watt: 'vermogen', leistung: 'vermogen', puissance: 'vermogen',
    aantalvelgen: 'velgen', inchmaat: 'inch', steekmaat: 'steek', lochkreis: 'steek', etwaarde: 'et', et: 'et',
    garantie: 'garantie', gewahrleistung: 'garantie', garantiezeit: 'garantie', warranty: 'garantie',
    ean: '-', sku: '-', artikelnummer: '-'
  };
  /* Higher or lower is clearly better: highlight the best value */
  var BETTER = { price: 'lo', lumen: 'hi', front: 'hi', rear: 'hi' };

  function esc(s) {
    return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }
  function normKey(s) {
    return String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[^a-z0-9]/g, '');
  }
  function money(cents) {
    var n = parseInt(cents, 10);
    if (isNaN(n)) return '';
    var parts = (n / 100).toFixed(2).split('.');
    var s = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + parts[1];
    return s.replace(/,00$/, LANG === 'fr' ? ',00' : ',-');
  }
  function num(n) { return LANG === 'en' ? String(n) : String(n).replace('.', ','); }

  /* ---- Storage ----------------------------------------------------------- */

  function readState() {
    var st = null;
    try { st = JSON.parse(localStorage.getItem(KEY) || 'null'); } catch (e) { st = null; }
    if (!st || !Array.isArray(st.items) || Date.now() - (st.at || 0) > TTL) st = { items: [], at: Date.now() };
    return st;
  }
  var state = readState();
  function list() { return state.items; }
  function save(items) {
    state.items = items;
    state.at = Date.now();
    try { localStorage.setItem(KEY, JSON.stringify(state)); } catch (e) {}
  }
  function savePrefs() {
    try { localStorage.setItem(KEY, JSON.stringify(state)); } catch (e) {}
  }
  try { sessionStorage.removeItem('vct-cmp'); } catch (e) {}
  function modeOn() { return !!state.mode || list().length > 0; }
  function setMode(on) {
    state.mode = !!on;
    if (!on) state.items = [];
    state.at = Date.now();
    savePrefs();
    if (!on) clearFlash();
    refresh();
  }
  function syncMode() {
    var on = modeOn();
    document.documentElement.classList.toggle('vct-cmp-mode', on);
    var b = document.querySelectorAll('[data-vct-cmp-mode]');
    for (var i = 0; i < b.length; i++) b[i].setAttribute('aria-pressed', on ? 'true' : 'false');
  }

  /* ---- Same kind ----------------------------------------------------------- */

  var TAX = {};
  (CFG.tax || []).forEach(function (r) {
    var h = r[0];
    if (!h) return;
    var n = TAX[h] || (TAX[h] = { p: [], t: r[2] || '', d: 0 });
    if (r[1] && n.p.indexOf(r[1]) < 0) n.p.push(r[1]);
    if ((r[3] || 1) > n.d) { n.d = r[3] || 1; n.t = r[2] || n.t; }
  });
  var BLOCK = /^(alle-producten|all|all-products.*|aanbiedingen|sale|eol|nieuw.*|new.*|frontpage|orderly.*|nada.*|tryon.*|\d+(-\d+)?|\d+x\d+)$/i;

  function kindOf(p) {
    var cols = String(p.c || '').split('|').map(function (s) {
      var i = s.lastIndexOf(':');
      return { h: (i < 0 ? s : s.slice(0, i)).trim(), n: parseInt(s.slice(i + 1), 10) || 9999 };
    }).filter(function (c) { return c.h && !BLOCK.test(c.h); });
    var nodes = cols.filter(function (c) { return TAX[c.h]; });
    if (nodes.length) {
      var deep = Math.max.apply(null, nodes.map(function (c) { return TAX[c.h].d; }));
      var k = nodes.filter(function (c) { return TAX[c.h].d === deep; }).sort(function (a, b) { return a.n - b.n; });
      return { k: k.map(function (c) { return c.h; }), l: TAX[k[0].h].t };
    }
    var vendor = normKey(p.v);
    var rest = cols.filter(function (c) { return normKey(c.h) !== vendor; }).sort(function (a, b) { return a.n - b.n; });
    return { k: rest.length ? [rest[0].h] : [], l: '' };
  }
  function ancestors(hs) {
    var out = [], todo = hs.slice();
    while (todo.length) {
      var n = TAX[todo.shift()];
      if (!n) continue;
      n.p.forEach(function (h) { if (out.indexOf(h) < 0) { out.push(h); todo.push(h); } });
    }
    return out;
  }
  function meets(a, b) { return a.some(function (h) { return b.indexOf(h) > -1; }); }
  function sameKind(a, b) {
    var ka = a.k || [], kb = b.k || [];
    if (!ka.length || !kb.length) return true;
    return meets(ka, kb) || meets(ka, ancestors(kb)) || meets(kb, ancestors(ka));
  }
  function groupLabel() {
    var first = list()[0];
    return first && first.l ? first.l : '';
  }
  function titleText() {
    var l = groupLabel();
    return l ? tr(t.titleKind, { kind: l }) : t.title;
  }

  /* ---- Add and remove ------------------------------------------------------ */

  function parseData(el) {
    try {
      var d = JSON.parse(el.getAttribute('data-vct-cmp'));
      if (!d || !d.h) return null;
      var k = kindOf(d);
      d.k = k.k;
      d.l = k.l;
      delete d.c;
      return d;
    } catch (e) { return null; }
  }
  function has(h) { return list().some(function (p) { return p.h === h; }); }
  function removeItem(h) {
    save(list().filter(function (p) { return p.h !== h; }));
    refresh();
  }
  /* Returns true when the product is now in the comparison */
  function addItem(d) {
    if (!d) return false;
    var items = list();
    if (items.some(function (p) { return p.h === d.h; })) return true;
    if (items.length && !sameKind(items[0], d)) {
      var l = groupLabel();
      flash(l ? tr(t.other, { kind: l }) : t.otherNoKind, d);
      return false;
    }
    if (items.length >= max()) {
      flash(tr(t.max, { n: max() }));
      return false;
    }
    items.push(d);
    state.mode = true;
    save(items);
    clearFlash();
    refresh();
    return true;
  }
  function startNew(d) {
    state.mode = true;
    save([d]);
    clearFlash();
    refresh();
  }

  /* ---- Toggles on cards and the product page ------------------------------ */

  function syncToggles() {
    syncMode();
    var chosen = list().map(function (p) { return p.h; });
    var boxes = document.querySelectorAll('[data-vct-cmp-toggle]');
    for (var i = 0; i < boxes.length; i++) {
      var on = chosen.indexOf(boxes[i].value) > -1;
      if (boxes[i].checked !== on) boxes[i].checked = on;
      var lab = boxes[i].closest('.vct-cmp-toggle');
      if (lab) lab.classList.toggle('is-on', on);
    }
    var btns = document.querySelectorAll('[data-vct-cmp-add]');
    for (var j = 0; j < btns.length; j++) {
      var d = btns[j]._vctCmp || (btns[j]._vctCmp = parseData(btns[j]));
      var pressed = !!d && chosen.indexOf(d.h) > -1;
      btns[j].setAttribute('aria-pressed', pressed ? 'true' : 'false');
      var span = btns[j].querySelector('span');
      if (span) span.textContent = pressed ? t.inCompare : t.compare;
    }
  }

  document.addEventListener('change', function (e) {
    var box = e.target;
    if (!box || !box.hasAttribute || !box.hasAttribute('data-vct-cmp-toggle')) return;
    if (!box.checked) { removeItem(box.value); return; }
    var card = box.closest('[data-vct-cmp]');
    if (!addItem(card && parseData(card))) box.checked = false;
    syncToggles();
  });
  document.addEventListener('click', function (e) {
    var mode = e.target.closest && e.target.closest('[data-vct-cmp-mode]');
    if (mode) {
      e.preventDefault();
      e.stopPropagation();
      setMode(!modeOn());
      return;
    }
    var btn = e.target.closest && e.target.closest('[data-vct-cmp-add]');
    if (!btn) return;
    e.preventDefault();
    var d = btn._vctCmp || (btn._vctCmp = parseData(btn));
    if (!d) return;
    if (has(d.h)) removeItem(d.h); else addItem(d);
    syncToggles();
  });

  /* ---- Bar ----------------------------------------------------------------- */

  var bar = null;
  var flashTimer = null;
  var flashState = null;
  function ensureBar() {
    if (bar) return bar;
    bar = document.createElement('div');
    bar.className = 'vct-cmp-bar';
    bar.setAttribute('role', 'region');
    bar.setAttribute('aria-label', t.title);
    bar.hidden = true;
    document.body.appendChild(bar);
    bar.addEventListener('click', function (e) {
      var rm = e.target.closest('[data-vct-cmp-remove]');
      if (rm) { removeItem(rm.getAttribute('data-vct-cmp-remove')); return; }
      if (e.target.closest('[data-vct-cmp-clear]')) { save([]); clearFlash(); refresh(); return; }
      if (e.target.closest('[data-vct-cmp-stop]')) { setMode(false); return; }
      if (e.target.closest('[data-vct-cmp-new]')) { if (flashState && flashState.d) startNew(flashState.d); return; }
      if (e.target.closest('[data-vct-cmp-dismiss]')) { clearFlash(); renderBar(); return; }
      var open = e.target.closest('[data-vct-cmp-open]');
      if (open && !open.disabled) openSheet(open);
    });
    return bar;
  }
  function flash(msg, d) {
    flashState = { msg: msg, d: d || null };
    renderBar(true);
    clearTimeout(flashTimer);
    if (!d) flashTimer = setTimeout(function () { clearFlash(); renderBar(); }, 5000);
  }
  function clearFlash() { flashState = null; clearTimeout(flashTimer); }

  function thumb(p) {
    return '<img src="' + esc(p.i) + '" alt="" width="48" height="48" loading="lazy">';
  }
  function renderBar(forceShow) {
    var items = list();
    var el = ensureBar();
    var showEmpty = state.mode && !IS_PDP;
    if (!items.length && !forceShow && !showEmpty) {
      el.hidden = true;
      document.documentElement.classList.remove('vct-cmp-open');
      return;
    }
    var compact = IS_PDP && mqPhone.matches;
    el.classList.toggle('is-compact', compact);
    var msg = '';
    if (flashState) {
      msg = '<div class="vct-cmp-bar__msg" role="status"><p>' + esc(flashState.msg) + '</p>' +
        (flashState.d ? '<button type="button" class="vct-btn vct-btn--outline vct-btn--sm" data-vct-cmp-new>' + esc(t.startNew) + '</button>' +
          '<button type="button" class="vct-cmp-bar__x" data-vct-cmp-dismiss aria-label="' + esc(t.close) + '">×</button>' : '') +
        '</div>';
    }
    var canOpen = items.length >= 2;
    var html = msg;
    if (items.length && compact) {
      html += '<div class="vct-cmp-bar__pill">' +
        '<button type="button" class="vct-cmp-bar__open" data-vct-cmp-open' + (canOpen ? '' : ' disabled') + '>' +
          '<span class="vct-cmp-bar__stack" aria-hidden="true">' + items.map(thumb).join('') + '</span>' +
          '<span>' + esc(canOpen ? tr(t.compareN, { n: items.length }) : t.pickMore) + '</span>' +
        '</button>' +
        '<button type="button" class="vct-cmp-bar__x" data-vct-cmp-stop aria-label="' + esc(t.stop) + '">×</button>' +
      '</div>';
    } else {
      var thumbs = items.map(function (p) {
        return '<li>' + thumb(p) + '<span>' + esc(p.t) + '</span>' +
          '<button type="button" data-vct-cmp-remove="' + esc(p.h) + '" aria-label="' + esc(t.remove + ': ' + p.t) + '">×</button></li>';
      }).join('');
      for (var i = items.length; i < max(); i++) thumbs += '<li class="is-empty" aria-hidden="true"></li>';
      html +=
        '<div class="vct-cmp-bar__head"><strong>' + esc(titleText()) + '</strong><span>' + esc(tr(t.count, { n: items.length, max: max() })) + '</span></div>' +
        '<ul class="vct-cmp-bar__items">' + thumbs + '</ul>' +
        '<div class="vct-cmp-bar__actions">' +
          (canOpen ? '' : '<p class="vct-cmp-bar__hint">' + esc(max() > 3 ? t.pick4 : t.pick3) + '</p>') +
          (items.length ? '<button type="button" class="vct-btn vct-btn--brand vct-btn--sm" data-vct-cmp-open' + (canOpen ? '' : ' disabled') + '>' + esc(tr(t.compareN, { n: items.length })) + '</button>' : '') +
          (items.length ? '<button type="button" class="vct-cmp-bar__clear" data-vct-cmp-clear>' + esc(t.clear) + '</button>' : '') +
          '<button type="button" class="vct-cmp-bar__clear" data-vct-cmp-stop>' + esc(t.stop) + '</button>' +
        '</div>';
    }
    el.innerHTML = html;
    el.hidden = false;
    lift();
    document.documentElement.classList.add('vct-cmp-open');
  }
  /* Keep the bar above the theme's sticky buy bar when that bar is in view at the bottom */
  var liftRaf = 0;
  function lift() {
    if (liftRaf) return;
    liftRaf = requestAnimationFrame(function () {
      liftRaf = 0;
      if (!bar || bar.hidden) return;
      var sb = document.getElementById('sticky-add-to-cart'), up = 0;
      if (sb) {
        var cs = getComputedStyle(sb), r = sb.getBoundingClientRect();
        if (cs.display !== 'none' && cs.visibility === 'visible' && cs.position === 'fixed' && r.height > 0 && r.top < window.innerHeight && r.bottom > window.innerHeight - 4) {
          up = Math.max(0, Math.round(window.innerHeight - r.top));
        }
      }
      var v = up + 'px';
      if (bar.style.getPropertyValue('--vct-cmp-lift') !== v) bar.style.setProperty('--vct-cmp-lift', v);
    });
  }
  function refresh() {
    syncToggles();
    renderBar(!!flashState);
    if (sheet && !sheet.hidden) {
      if (list().length) renderSheet(); else closeSheet();
    }
  }

  /* ---- Rows ---------------------------------------------------------------- */

  function cleanVal(v) {
    var s = String(v == null ? '' : v).replace(/<[^>]*>/g, '').trim();
    if (!s || s === '-' || s === '–') return null;
    if (/^true$/i.test(s)) return t.yes;
    if (/^false$/i.test(s)) return t.no;
    return s.replace(/(\d)\.0(\s|$)/g, '$1$2');
  }
  function camCell(key, s) {
    var v = s ? s[key] : null;
    if (v == null || v === false || v === '') return null;
    switch (key) {
      case 'cams': return t['cam' + v] || String(v);
      case 'wifi': case 'gsensor': case 'hardwire': return t.yes;
      case 'gps': return t.builtIn;
      case 'screen': return num(v) + ' ' + t.inchU;
      case 'parking': return s.parking_note === 'hardwire' ? t.parkingHw : t.yes;
      case 'night': return v === 'ir' ? t.ir : v === 'mode' ? t.mode : String(v);
      case 'sd': return tr(t.sdUpTo, { n: v });
      default: return String(v);
    }
  }
  /* Dashcams without the metafield vct.vergelijk: only what the title clearly says (never "no") */
  function camFromTitle(p) {
    if (p.s || (p.k || []).indexOf('dashcams') < 0) return p.s || null;
    var tt = String(p.t || ''), s = {};
    if (/\b3\s*ch\b|3[\s-]?kanaals?|voor,? achter en interieur/i.test(tt)) s.cams = 3;
    else if (/\b2\s*ch\b|voor en achter|vorne und hinten|avant et arri[eè]re|front (and|\+) rear|dual/i.test(tt)) s.cams = 2;
    else if (/\b1\s*ch\b/i.test(tt)) s.cams = 1;
    var res = tt.match(/\b(\d{3,4}p)\b/i) || tt.match(/\b(\dK)\b/);
    if (res) s.front = res[1];
    if (/wi-?fi|wlan/i.test(tt)) s.wifi = true;
    if (/\bgps\b/i.test(tt)) s.gps = true;
    if (/g[\s-]?sensor/i.test(tt)) s.gsensor = true;
    if (/parking|parkeer|park(ü|ue)berwachung/i.test(tt)) s.parking = true;
    if (/nacht(zicht|modus|sicht)|night/i.test(tt)) s.night = 'mode';
    var sd = tt.match(/(\d{2,3})\s*GB\s*(ondersteuning|support|unterst)/i);
    if (sd) s.sd = sd[1];
    return Object.keys(s).length ? s : null;
  }
  /* Specification values of one product: metafields first, then the lines of the product page */
  function specsOf(p) {
    var out = {}, extra = [];
    var x = p.x || {};
    Object.keys(x).forEach(function (k) {
      if (k === 'garantie') return;
      var v = cleanVal(x[k]);
      if (v != null) out[k] = v;
    });
    (p.y || []).forEach(function (line) {
      var label = String(line[0] || '').trim(), v = cleanVal(line[1]);
      if (!label || v == null) return;
      var key = SYN[normKey(label)];
      if (key === '-' || key === 'merk' || key === 'garantie') return;
      if (key) { if (out[key] == null) out[key] = v; return; }
      extra.push({ key: 'y:' + normKey(label), label: label, v: v });
    });
    if (out.lumen == null) {
      var m = String(p.t || '').match(/(\d{1,3}(?:[.\s]\d{3})+|\d+)\s*(?:lm|lumen)\b/i);
      if (m) out.lumen = m[1].replace(/[.\s]/g, '') + ' lumen';
    }
    if (out.kelvin && /^\d{4,5}$/.test(out.kelvin)) out.kelvin += 'K';
    return { s: out, extra: extra };
  }
  function warranty(p) {
    var y = p.x && p.x.garantie ? parseInt(p.x.garantie, 10) : (p.pc >= 10000 ? 2 : 1);
    return y === 1 ? t.years1 : tr(t.yearsN, { n: y });
  }
  function stars(r) {
    if (!r || r <= 0) return null;
    var pct = Math.max(0, Math.min(100, (r / 5) * 100));
    var label = tr(t.ratingOf, { r: num(Math.round(r * 10) / 10) });
    return '<span class="vct-cmp-stars" role="img" aria-label="' + esc(label) + '"><span class="vct-cmp-stars__fill" style="width:' + pct.toFixed(0) + '%"></span></span>';
  }
  function stockText(p) {
    if (p.a === 1) return '<span class="vct-cmp-stock is-in">' + esc(t.inStock) + '</span>';
    if (p.a === 2) return '<span class="vct-cmp-stock is-back">' + esc(t.backorder) + '</span>';
    return '<span class="vct-cmp-stock is-out">' + esc(t.soldOut) + '</span>';
  }
  function numeric(key, v, p) {
    if (key === 'price') return p.pc;
    if (v == null) return null;
    var s = String(v);
    if (key === 'lumen') { var l = s.replace(/[.\s](?=\d{3})/g, '').match(/\d+/); return l ? +l[0] : null; }
    if (key === 'front' || key === 'rear') {
      var wh = s.match(/(\d{3,4})\s*[x×]\s*(\d{3,4})/);
      if (wh) return Math.min(+wh[1], +wh[2]);
      var pp = s.match(/(\d{3,4})\s*p\b/i);
      if (pp) return +pp[1];
      var k = s.match(/(\d(?:[.,]\d)?)\s*k\b/i);
      if (k) { var kk = parseFloat(k[1].replace(',', '.')); return kk >= 4 ? 2160 : kk >= 2.5 ? 1600 : kk >= 2 ? 1440 : 1080; }
      return null;
    }
    return null;
  }
  function buildRows(items) {
    var specs = items.map(specsOf);
    var rows = [];
    function add(key, label, vals, html) {
      if (!vals.some(function (v) { return v != null; })) return;
      rows.push({ key: key, label: label, vals: vals, html: !!html });
    }
    add('price', t.price, items.map(function (p) { return money(p.pc); }));
    add('rating', t.rating, items.map(function (p) { return stars(p.r); }), true);
    add('stock', t.stock, items.map(stockText), true);
    add('merk', t.merk, items.map(function (p) { return p.v || null; }));
    var cams = items.map(camFromTitle);
    CAM_ROWS.forEach(function (k) { add(k, t[k], cams.map(function (c) { return camCell(k, c); })); });
    SPEC_ROWS.forEach(function (k) { add(k, t[k], specs.map(function (s) { return s.s[k] != null ? s.s[k] : null; })); });
    var extraKeys = [];
    specs.forEach(function (s) { s.extra.forEach(function (e) { if (!extraKeys.some(function (x) { return x.key === e.key; })) extraKeys.push(e); }); });
    extraKeys.forEach(function (e) {
      add(e.key, e.label, specs.map(function (s) {
        var f = s.extra.filter(function (x) { return x.key === e.key; })[0];
        return f ? f.v : null;
      }));
    });
    add('garantie', t.garantie, items.map(warranty));
    rows.forEach(function (r) {
      var cmp = r.vals.map(function (v) { return v == null ? '\u0000' : String(v).toLowerCase().replace(/\s+/g, ' '); });
      r.same = cmp.every(function (v) { return v === cmp[0]; });
      r.best = [];
      var dir = BETTER[r.key];
      if (dir && items.length > 1) {
        var ns = r.vals.map(function (v, i) { return numeric(r.key, v, items[i]); });
        var known = ns.filter(function (n) { return n != null && !isNaN(n); });
        if (known.length >= 2) {
          var best = dir === 'hi' ? Math.max.apply(null, known) : Math.min.apply(null, known);
          if (known.some(function (n) { return n !== best; })) r.best = ns.map(function (n) { return n === best; });
        }
      }
    });
    return rows;
  }

  /* ---- Fresh price and stock when the comparison opens --------------------- */

  var fetched = {};
  function freshen(items) {
    items.forEach(function (p) {
      if (fetched[p.h]) return;
      fetched[p.h] = 1;
      fetch(ROOT.replace(/\/?$/, '/') + 'products/' + encodeURIComponent(p.h) + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (j) {
          if (!j || !j.variants) return;
          var v = j.variants.filter(function (x) { return x.available; })[0] || j.variants[0];
          var cur = list().filter(function (x) { return x.h === p.h; })[0];
          if (!cur || !v) return;
          var changed = false;
          function set(k, val) { if (val != null && cur[k] !== val) { cur[k] = val; changed = true; } }
          set('pc', v.price);
          set('n', j.variants.length);
          set('id', v.id);
          if (!j.available) set('a', 0); else if (cur.a === 0) set('a', 1);
          if (changed) { save(list()); renderBar(); if (sheet && !sheet.hidden) renderSheet(); }
        })
        .catch(function () {});
    });
  }

  /* ---- Sheet / panel -------------------------------------------------------- */

  var sheet = null;
  var lastFocus = null;
  var savedY = 0;
  var closeTimer = null;
  function ensureSheet() {
    if (sheet) return sheet;
    sheet = document.createElement('div');
    sheet.className = 'vct-cmp-dialog';
    sheet.setAttribute('role', 'dialog');
    sheet.setAttribute('aria-modal', 'true');
    sheet.setAttribute('aria-labelledby', 'vct-cmp-title');
    sheet.hidden = true;
    document.body.appendChild(sheet);
    sheet.addEventListener('click', function (e) {
      if (e.target === sheet || e.target.closest('[data-vct-cmp-close]')) { closeSheet(); return; }
      var rm = e.target.closest('[data-vct-cmp-remove]');
      if (rm) {
        var items = list();
        var idx = items.map(function (p) { return p.h; }).indexOf(rm.getAttribute('data-vct-cmp-remove'));
        removeItem(rm.getAttribute('data-vct-cmp-remove'));
        if (!sheet.hidden) {
          var rest = sheet.querySelectorAll('[data-vct-cmp-remove]');
          var next = rest[Math.min(idx, rest.length - 1)] || sheet.querySelector('[data-vct-cmp-close]');
          if (next) next.focus({ preventScroll: true });
        }
        return;
      }
      var buy = e.target.closest('[data-vct-cmp-buy]');
      if (buy) addToCart(buy);
    });
    sheet.addEventListener('change', function (e) {
      if (e.target && e.target.hasAttribute('data-vct-cmp-diff')) {
        state.diff = e.target.checked;
        savePrefs();
        sheet.querySelector('.vct-cmp-table').classList.toggle('is-diff-only', state.diff);
      }
    });
    sheet.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { e.preventDefault(); closeSheet(); return; }
      if (e.key !== 'Tab') return;
      var f = Array.prototype.filter.call(sheet.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])'), function (el) {
        return el.offsetParent !== null || el === document.activeElement;
      });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && (document.activeElement === first || !sheet.contains(document.activeElement))) { e.preventDefault(); last.focus({ preventScroll: true }); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus({ preventScroll: true }); }
    });
    return sheet;
  }
  function colHead(p) {
    var buy;
    if (!p.a) buy = '<a class="vct-btn vct-btn--outline vct-btn--sm vct-btn--block" href="' + esc(p.u) + '">' + esc(t.view) + '</a>';
    else if ((p.n || 1) > 1 || !p.id) buy = '<a class="vct-btn vct-btn--outline vct-btn--sm vct-btn--block" href="' + esc(p.u) + '">' + esc(t.choose) + '</a>';
    else buy = '<button type="button" class="vct-btn vct-btn--cta vct-btn--sm vct-btn--block" data-vct-cmp-buy="' + esc(p.id) + '">' + esc(t.addCart) + '</button>';
    return '<th scope="col"><div class="vct-cmp-col">' +
      '<button type="button" class="vct-cmp-col__rm" data-vct-cmp-remove="' + esc(p.h) + '" aria-label="' + esc(t.remove + ': ' + p.t) + '">×</button>' +
      '<a href="' + esc(p.u) + '" class="vct-cmp-col__link">' +
        '<span class="vct-cmp-col__img"><img src="' + esc(p.i) + '" alt="" width="120" height="120" loading="lazy"></span>' +
        '<span class="vct-cmp-col__name">' + esc(p.t) + '</span></a>' +
      '<strong class="vct-cmp-col__price">' + esc(money(p.pc)) + '</strong>' +
      (stars(p.r) || '') +
      '<div class="vct-cmp-col__buy">' + buy + '<p class="vct-cmp-col__msg" aria-live="polite"></p></div>' +
    '</div></th>';
  }
  function renderSheet() {
    var items = list();
    var rows = buildRows(items);
    var specRows = rows.filter(function (r) { return r.key !== 'price'; });
    var canDiff = items.length > 1 && specRows.some(function (r) { return r.same; }) && specRows.some(function (r) { return !r.same; });
    if (state.diff == null) state.diff = rows.length > 4;
    var diffOn = canDiff && state.diff;
    var body = rows.map(function (r) {
      return '<tr class="' + (r.same && r.key !== 'price' ? 'is-same' : 'is-diff') + '"><th scope="row">' + esc(r.label) + '</th>' + r.vals.map(function (v, i) {
        var best = r.best[i];
        var inner = v == null ? '<span class="vct-cmp-table__none">–</span>' : (r.html ? v : esc(v));
        return '<td' + (best ? ' class="is-best"' : '') + '>' + inner + (best ? '<span class="vct-cmp-sr"> (' + esc(t.best) + ')</span>' : '') + '</td>';
      }).join('') + '</tr>';
    }).join('');
    var scroller = sheet.querySelector('.vct-cmp-dialog__scroll');
    var keepX = scroller ? scroller.scrollLeft : 0, keepY = scroller ? scroller.scrollTop : 0;
    sheet.innerHTML =
      '<div class="vct-cmp-dialog__panel">' +
        '<header class="vct-cmp-dialog__head"><h2 id="vct-cmp-title">' + esc(titleText()) + '</h2>' +
          (canDiff ? '<label class="vct-cmp-diff"><input type="checkbox" data-vct-cmp-diff' + (diffOn ? ' checked' : '') + '> <span>' + esc(t.diffOnly) + '</span></label>' : '') +
          '<button type="button" class="vct-cmp-dialog__close" data-vct-cmp-close aria-label="' + esc(t.close) + '">×</button></header>' +
        '<div class="vct-cmp-dialog__scroll"><table class="vct-cmp-table' + (diffOn ? ' is-diff-only' : '') + '" style="--vct-cmp-cols:' + items.length + '">' +
          '<thead><tr><td class="vct-cmp-table__corner"></td>' + items.map(colHead).join('') + '</tr></thead>' +
          '<tbody>' + body + '</tbody></table></div>' +
        '<p class="vct-cmp-dialog__note">' + esc(t.note) + '</p>' +
      '</div>';
    var sc = sheet.querySelector('.vct-cmp-dialog__scroll');
    if (sc) { sc.scrollLeft = keepX; sc.scrollTop = keepY; }
  }
  function lockScroll() {
    savedY = window.pageYOffset || document.documentElement.scrollTop || 0;
    var gap = window.innerWidth - document.documentElement.clientWidth;
    if (gap > 0) document.body.style.paddingRight = gap + 'px';
    document.documentElement.classList.add('vct-cmp-locked');
    restoreY();
  }
  function unlockScroll() {
    document.documentElement.classList.remove('vct-cmp-locked');
    document.body.style.paddingRight = '';
    restoreY();
  }
  function restoreY() {
    if (Math.abs((window.pageYOffset || 0) - savedY) > 1) {
      try { window.scrollTo({ top: savedY, left: 0, behavior: 'instant' }); } catch (e) { window.scrollTo(0, savedY); }
    }
  }
  function openSheet(trigger) {
    if (list().length < 2) return;
    ensureSheet();
    clearTimeout(closeTimer);
    var wasOpen = !sheet.hidden;
    if (!wasOpen) lastFocus = trigger || document.activeElement;
    renderSheet();
    if (!wasOpen) lockScroll();
    sheet.hidden = false;
    void sheet.offsetWidth;
    sheet.classList.add('is-open');
    var close = sheet.querySelector('[data-vct-cmp-close]');
    if (close) close.focus({ preventScroll: true });
    restoreY();
    freshen(list());
  }
  function closeSheet() {
    if (!sheet || sheet.hidden) return;
    sheet.classList.remove('is-open');
    clearTimeout(closeTimer);
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    closeTimer = setTimeout(function () {
      sheet.hidden = true;
      unlockScroll();
    }, reduce ? 0 : 200);
    var back = lastFocus && document.contains(lastFocus) ? lastFocus : (bar && bar.querySelector('[data-vct-cmp-open]'));
    if (back && back.focus) back.focus({ preventScroll: true });
    restoreY();
  }
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && sheet && !sheet.hidden && !sheet.contains(document.activeElement)) closeSheet();
  });

  /* ---- Quick add (single-variant products) --------------------------------- */

  function addToCart(btn) {
    if (btn.disabled) return;
    var id = parseInt(btn.getAttribute('data-vct-cmp-buy'), 10);
    var msg = btn.parentNode.querySelector('.vct-cmp-col__msg');
    var label = btn.textContent;
    btn.disabled = true;
    btn.setAttribute('aria-busy', 'true');
    btn.textContent = t.adding;
    if (msg) msg.textContent = '';
    fetch(ROOT.replace(/\/?$/, '/') + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }], sections: 'side-cart', sections_url: window.location.pathname })
    })
      .then(function (r) { if (!r.ok) throw new Error(String(r.status)); return r.json(); })
      .then(function (res) {
        refreshCart(res);
        btn.textContent = t.added;
        btn.classList.add('is-done');
        setTimeout(function () { btn.textContent = label; btn.classList.remove('is-done'); btn.disabled = false; btn.removeAttribute('aria-busy'); }, 2200);
      })
      .catch(function () {
        btn.textContent = label;
        btn.disabled = false;
        btn.removeAttribute('aria-busy');
        if (msg) msg.textContent = t.addFail;
      });
  }
  function refreshCart(res) {
    var html = res && res.sections && res.sections['side-cart'];
    var box = document.getElementById('cart');
    if (html && box) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var sec = doc.querySelector('#shopify-section-side-cart');
      if (sec) {
        box.innerHTML = sec.innerHTML;
        ['modulePanel', 'listCart', 'semanticInput', 'formValidate', 'accordeon'].forEach(function (n) { window.dispatchEvent(new CustomEvent(n)); });
      }
    }
    fetch(ROOT.replace(/\/?$/, '/') + 'cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      document.querySelectorAll('#cart-count,[data-cart-count],[data-cart-item-count],.cart-count,.cart__count').forEach(function (el) {
        el.textContent = cart.item_count;
        el.setAttribute('data-count', cart.item_count);
        if (cart.item_count > 0) el.removeAttribute('hidden');
      });
      document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cart } }));
    }).catch(function () {});
  }

  /* ---- Start --------------------------------------------------------------- */

  function init() {
    syncToggles();
    ensureBar();
    renderBar();
    /* Cards come back after filtering or paging */
    if ('MutationObserver' in window) {
      var timer = null;
      new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) {
          if (bar && bar.contains(muts[i].target)) continue;
          if (sheet && sheet.contains(muts[i].target)) continue;
          if (!timer) timer = setTimeout(function () { timer = null; syncToggles(); }, 150);
          return;
        }
      }).observe(document.body, { childList: true, subtree: true });
    }
    /* Another tab changed the comparison */
    window.addEventListener('storage', function (e) {
      if (e.key !== KEY) return;
      state = readState();
      refresh();
    });
    window.addEventListener('scroll', lift, { passive: true });
    window.addEventListener('resize', lift);
    document.addEventListener('transitionend', function (e) { if (e.target && e.target.id === 'sticky-add-to-cart') lift(); }, true);
    var sb = document.getElementById('sticky-add-to-cart');
    if (sb && window.ResizeObserver) new ResizeObserver(lift).observe(sb);
    if (sb && 'MutationObserver' in window) new MutationObserver(lift).observe(sb, { attributes: true });
    new MutationObserver(lift).observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
    function onMq() { renderBar(); }
    if (mqPhone.addEventListener) { mqPhone.addEventListener('change', onMq); mqWide.addEventListener('change', onMq); }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
